module.exports = __webpack_public_path__ + "img/img-4.c6c2ea14.png";